import { Box } from '@mui/material';
import React from 'react';
import SmallDeviceWorks from './WorksDetails/SmallDeviceWorks';
import Works from './WorksDetails/Works';
import WorksDetailsTop from './WorksDetails/WorksDetailsTop';

const HowItWorks = () => {
    return (
        <div>
            <Box sx={{ mx: { xs: 1.2, sm: 3.5, md: 6, lg: 9, xl: 28 } }}>
                <WorksDetailsTop />
                <Box sx={{ display: { xs: 'none', sm: 'inline' } }}>
                    <Works />
                </Box>
                <Box sx={{ display: { sm: 'none' } }}>
                    <SmallDeviceWorks />
                </Box>
            </Box>
        </div>
    );
};

export default HowItWorks;